import React from "react";
import classNames from "classnames";
import Button, { ButtonProps } from "../../Button";
import Loader from "../../Loader";

interface Props extends ButtonProps {
  submitting?: boolean;
  disabled?: boolean;
  icon?: string;
  showIcon?: boolean;
  nextToInputField?: boolean;
  extraClasses?: string;
}

const SubmitBtn: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    children,
    submitting,
    disabled = false,
    showIcon = false,
    icon = "",
    nextToInputField = false,
    extraClasses = "",
    ...rest
  } = props;

  const buttonClasses = classNames(
    "capitalrx-submitbtn",
    { "capitalrx-submitbtn-submitting": submitting },
    { "capitalrx-submitbtn-next-to-input": nextToInputField },
    { "caprx-btn:disabled": disabled },
    extraClasses,
  );

  return (
    <Button type="submit" disabled={submitting || disabled} extraClasses={buttonClasses} data-testid="test__submit-btn" fullWidth {...rest}>
      <span className="submitbtn-label">{children}</span>
      {showIcon && <span className={`submitbtn-icon ${icon}`} />}
      <span className="submitbtn-loader">
        <Loader />
      </span>
    </Button>
  );
};

export default SubmitBtn;
